import {useTranslation} from 'hooks/translations/useCustomTranslation';
import {useGetTranslatedCategory} from 'hooks/useGetTranslatedCategory';
import {useRouter} from 'next/router';
import React, {useEffect} from 'react';
import {useFormContext} from 'react-hook-form';

import {palette} from 'styles/mui/scss';

import {Box, Typography} from 'components/basic-components';
import {CustomIcon} from 'components/basic-components/CustomIcon/CustomIcon';

import styles from './styles/formSelectCategory.module.scss';

const SelectCategory = () => {
  const {t} = useTranslation('bpr');

  return (
    <Box
      role="radiogroup"
      className={styles.wrapper}
      onKeyDown={e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          console.log('arrorRight');
          e.preventDefault();
          // move to the next value
        }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          // move to the previous value
        }
      }}
    >
      <CategoryButton value={t('bestpriceCategoryCar')} label={t('bestpriceCategoryCarLabel')} />
      <CategoryButton
        value={t('bestpriceCategoryTruck')}
        label={t('bestpriceCategoryTruckLabel')}
      />
    </Box>
  );
};

export default SelectCategory;

function CategoryButton({value, label}) {
  const {setValue, watch, register} = useFormContext();
  const {t} = useTranslation('bpr');

  const {locale} = useRouter();
  const getTranslatedCategory = useGetTranslatedCategory();

  useEffect(() => {
    setValue('category', getTranslatedCategory('pkw'));
  }, [locale]);

  const currentValue = watch('category');
  return (
    <>
      <input
        type="radio"
        id={`category-${value}`}
        value={value}
        {...register('category')}
        // onChange={e => setValue('category', value)}
        style={{display: 'none'}}
        // checked={currentValue === value}
      />
      <label
        htmlFor={`category-${value}`}
        // onClick={e => {
        //   e.preventDefault();
        //   setValue('category', value);
        // }}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setValue('category', value);
          }
        }}
        className={styles.button}
        tabIndex={0}
        role="radio"
        aria-checked={currentValue === value}
        style={{
          backgroundColor: value === currentValue ? 'rgba(254, 237, 1, 0.1)' : 'inherit',
          color: value === currentValue ? palette.colorPrimary : palette.colorMidGrey,
        }}
      >
        <CustomIcon
          className={styles.categoryIcon}
          name={t('bestpriceCategoryCar') === value ? 'car' : 'truck'}
        ></CustomIcon>
        <Typography variant="buttonCards" className={styles.label}>
          {label}
        </Typography>
      </label>
    </>
  );
}
